import { apiClient } from "../../utils/apiClient";
import type {
  FetchEmailsResponse,
  RecategorizeResponse,
  CategoryDefinitions,
  PropertyExtractionDefinitions,
} from "./types";

const BASE_URL = "/admin/shipment-email-category-validation";

export async function fetchCategoryDefinitions(): Promise<CategoryDefinitions> {
  const response = await apiClient.get<{ definitions: CategoryDefinitions }>(
    `${BASE_URL}/category-definitions`
  );
  return response.definitions;
}

export async function fetchPropertyExtractionDefinitions(): Promise<PropertyExtractionDefinitions> {
  const response = await apiClient.get<{
    definitions: PropertyExtractionDefinitions;
  }>(`${BASE_URL}/property-extraction-definitions`);
  return response.definitions;
}

export async function fetchEmailsByTag(
  tag: string,
  offset = 0,
  limit = 100,
  categories?: string[]
): Promise<FetchEmailsResponse> {
  const params = new URLSearchParams({
    tag,
    offset: offset.toString(),
    limit: limit.toString(),
  });

  // Add categories as comma-separated string if provided
  if (categories && categories.length > 0) {
    params.set("categories", categories.join(","));
  }

  const response = await apiClient.get<FetchEmailsResponse>(
    `${BASE_URL}/fetch-emails?${params}`
  );

  return response;
}

export async function recategorizeEmails(
  emailIds: string[],
  categoryDefinitions: CategoryDefinitions,
  propertyExtractionDefinitions?: PropertyExtractionDefinitions
): Promise<RecategorizeResponse> {
  const response = await apiClient.post<RecategorizeResponse>(
    `${BASE_URL}/recategorize`,
    {
      emailIds,
      categoryDefinitions,
      propertyExtractionDefinitions,
    }
  );

  return response;
}
